import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable, ReplaySubject } from 'rxjs';
import { DashBoardInterface } from './interfaces/dashboard';

/**
 * Estado de UI de UMA aba do dashboard — 100% runtime, nunca serializado.
 * Substitui o antigo ControllerInterface[] (busca linear por tabName).
 *
 * O ReplaySubject(1) por aba garante que:
 *  - gadgets só recebem o filtro da PRÓPRIA aba;
 *  - um gadget que assina tarde (ex.: ag-grid esperando gridReady)
 *    recebe a última emissão — sem race de inicialização.
 */
export class TabState {
  editMode = false;
  openMenu = false;
  isOver = false;
  showJSON = false;
  isFilterExpanded = false;
  /** layout mudou em modo edição (feedback visual de alteração pendente) */
  dirty = false;
  /** preferência serializada do último filtro (consumida pelo prompt-filter-view) */
  lastFilter?: string;
  /** snapshot da aba para restaurar ao cancelar a edição */
  oldJSON: DashBoardInterface | null = null;

  readonly jsonControl = new FormControl('');
  readonly filterForm: FormGroup;

  private readonly filterSubject = new ReplaySubject<FormGroup | null>(1);
  /** referência ESTÁVEL para bind no template ([events] dos gadgets) */
  readonly filterApplied$: Observable<FormGroup | null> = this.filterSubject.asObservable();

  constructor(public readonly tabName: string, fb: FormBuilder) {
    this.filterForm = fb.group({});
  }

  emitFilter(form: FormGroup | null): void {
    this.filterSubject.next(form);
  }
}
